<template>
    <div class="content TelemarketingGuard">
    	<van-row class="searchBar" style="padding: .2rem .35rem;">
            <div class="ckTime" style="width: auto;">
                <span @click="timeStartShow=true" style="margin-left:0;"><font v-text="formatDate(timeStart)"></font><van-icon name="arrow-down" /></span>
                <font style="line-height: .4rem;margin-left: .2rem;">至</font>
                <span @click="timeEndShow=true"><font v-text="formatDate(timeEnd)"></font><van-icon name="arrow-down" /></span>
            </div>
        </van-row>
    	<van-row style="background-color: #fff;padding: 0 .35rem;">
    		<div class="item">
    			<div class="item-body">
    				<hr size="1" color="#F6F6F7">
    				<div class="table">
    					<div class="table-body">
    						<van-row class="table-null" v-if="list.length==0">未查询到数据</van-row>
    						<van-row class="table-tr" style="font-size: .24rem;color: #606266;line-height: .4rem;" v-for="(item,index) in list" :key="index">
                                <van-col span="12"><font style="font-size: .32rem; color: #303133;">{{item.importTitle}}</font></van-col>
                                <van-col span="12" style="text-align: right;">
                                    <font style="font-size: .2rem; color: #606266;">导入量</font>&nbsp;
                                    <font style="font-size: .35rem;color: #FF0044;font-weight: bold;">{{item.totalCount}}</font>
                                </van-col>
                                <van-col span="24">
                                    <span style="font-size: .2rem;color: #909399;display: flex;align-items: center;">
                                        <van-icon name="clock-o" />&nbsp;
                                        <font>{{item.createTime}}</font>
                                    </span>
                                </van-col>
                                <van-col span="12">有效号码：{{item.validCount}}（{{item.validRate}}%）</van-col>
                                <van-col span="12">未拨号码：{{item.unCallCount}}（{{item.unCallRate}}%）</van-col>
                                <van-col span="12">风险号码：{{item.blackCount}}（{{item.blackRate}}%）</van-col>
                                <van-col span="12">重复号码：{{item.replaceCount}}（{{item.replaceRate}}%）</van-col>
                            </van-row>
    					</div>
    				</div>
    			</div>
    		</div>
    	</van-row>
        <van-popup v-model="timeStartShow" position="bottom">
            <van-datetime-picker v-model="timeStart" type="date" title="开始日期" :visible-item-count="3" @confirm="timeConfirm" @cancel="timeConfirm" />
        </van-popup>
        <van-popup v-model="timeEndShow" position="bottom">
            <van-datetime-picker v-model="timeEnd" type="date" title="结束日期" :visible-item-count="3" @confirm="timeConfirm" @cancel="timeConfirm"/>
        </van-popup>
    </div>
</template>
<script type="text/javascript">
	import axios from 'axios';
    import {queryImportPage} from '../../api';
    export default {
        name: 'TelemarketingGuard',
        data() {
            return {
                token:"",
                timeStartShow:false,
                timeEndShow:false,
                timeStart:new Date(this.getDate(0)),
                timeEnd:new Date(this.getDate(0)),
                list:[]
            }
        },
        methods: {
            getQueryString(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"); 
                var r = window.location.search.substr(1).match(reg); 
                if (r != null) return decodeURI(r[2]); return ""; 
            },
            getDate(days){
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * days);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                // return [start.getFullYear()+"-"+(start.getMonth()+1)+"-"+start.getDate(), end.getFullYear()+"-"+(end.getMonth()+1)+"-"+end.getDate()];
                var myyear = start.getFullYear();
                var mymonth = start.getMonth() + 1;
                var myweekday = start.getDate();
                // return start.getFullYear()+"-"+(start.getMonth()+1)+"-"+start.getDate();
                if (mymonth < 10) {
                    mymonth = "0" + mymonth;
                }
                if (myweekday < 10) {
                    myweekday = "0" + myweekday;
                }
                return (myyear + "-" + mymonth + "-" + myweekday);
            },
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            timeConfirm(v){
                this.timeStartShow = false;
                this.timeEndShow = false;
                this.queryImportPage();
            },
            queryImportPage(){
                queryImportPage({
                    createTimeStart:this.timeStart,
                    createTimeEnd:this.timeEnd,
                }).then((res) => {
                    if(res.code==1){
                        this.list = res.data;
                    }else{
                        this.$toast("错误信息:"+res.message);
                    }
                })
            }
        },
        mounted(){
            this.token = this.getQueryString("token");
            sessionStorage.setItem('token', this.token);
            this.queryImportPage();
    	}
	}
</script>
<style type="text/css">
	.TelemarketingGuard .item {}
	.TelemarketingGuard .item-title {
		color: #303133;
		font-size: .32rem;
		line-height: .94rem;
		position: relative;
	}
	.TelemarketingGuard .item-title .van-icon {
		position: absolute;
		right: 0;
		top: .31rem;
	}
</style>


// WEBPACK FOOTER //
// src/views/app/TelemarketingGuardList.vue


// WEBPACK FOOTER //
// src/views/app/TelemarketingGuardList.vue